<div class="card">
	<div class="card-header border-0 pt-6">
		<div class="card-title">
			<!-- <div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input
					type="text"
					class="form-control form-control-sm w-250px ps-13"
					placeholder="Search negotiations..."
					[value]="searchTerm"
					(input)="onSearch($event)"
					[disabled]="isLoading" />
				<button
					*ngIf="searchTerm"
					type="button"
					class="btn btn-sm btn-icon btn-light position-absolute end-0 me-2"
					(click)="clearSearch()"
					[disabled]="isLoading">
					<i class="ki-duotone ki-cross fs-3">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</button>
			</div> -->
		</div>
		<div class="card-toolbar">
			<div class="d-flex justify-content-end" data-table-toolbar="base">
				<button
					type="button"
					class="btn btn-sm btn-dark fw-bold d-flex me-3"
					(click)="toggleFilters()"
					[class.active]="showFilters">
					<i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Search</span>
					<span *ngIf="hasActiveFilters()" class="badge badge-circle badge-danger ms-2">!</span>
				</button>
				<!-- <button type="button" class="btn btn-sm btn-dark me-3 text-nowrap">
					<i class="ki-duotone ki-plus fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Add New Negotiation</span>
				</button> -->
			</div>
		</div>
	</div>

	<!-- Filters Section -->
	<div class="card-body border-top py-4 negotiations-filters" *ngIf="showFilters" [@slideInOut]>
		<div class="row g-4">
			<!-- Make -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Make</label>
				<app-searchable-select
					[options]="makeOptions"
					placeholder="All Makes"
					[(ngModel)]="filters.make"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Model -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Model</label>
				<app-searchable-select
					[options]="modelOptions"
					placeholder="All Models"
					[(ngModel)]="filters.model"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Min Year -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Min Year</label>
				<app-searchable-select
					[options]="yearOptions"
					placeholder="Any Year"
					[(ngModel)]="filters.minYear"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Max Year -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Max Year</label>
				<app-searchable-select
					[options]="yearOptions"
					placeholder="Any Year"
					[(ngModel)]="filters.maxYear"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Client Name/Email -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Client Name / Email</label>
				<input
					type="text"
					class="form-control form-control-sm"
					placeholder="Enter name or email"
					[(ngModel)]="filters.clientName">
			</div>

			<!-- Min Price -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Min Price</label>
				<input
					type="number"
					class="form-control form-control-sm"
					placeholder="Min Price"
					[(ngModel)]="filters.minPrice">
			</div>

			<!-- Max Price -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Max Price</label>
				<input
					type="number"
					class="form-control form-control-sm"
					placeholder="Max Price"
					[(ngModel)]="filters.maxPrice">
			</div>

			<!-- Status -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Status</label>
				<select
					class="form-select form-select-sm"
					[(ngModel)]="filters.status">
					<option value="">All Status</option>
					<option *ngFor="let status of filterDropdownData.statuses" [value]="status.value">
						{{ status.label }}
					</option>
				</select>
			</div>

			<!-- Transaction Stage -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Transaction Stage</label>
				<select
					class="form-select form-select-sm"
					[(ngModel)]="filters.transactionStage">
					<option value="">All Stages</option>
					<option *ngFor="let stage of filterDropdownData.transactionStages" [value]="stage.value">
						{{ stage.label }}
					</option>
				</select>
			</div>

			<!-- Country -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Country</label>
				<app-searchable-select
					[options]="countryOptions"
					placeholder="All Countries"
					[(ngModel)]="filters.country"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Source -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Source</label>
				<app-searchable-select
					[options]="sourceOptions"
					placeholder="All Sources"
					[(ngModel)]="filters.source"
					size="sm"
					[clearable]="true">
				</app-searchable-select>
			</div>

			<!-- Search Keywords -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Search Keywords</label>
				<input
					type="text"
					class="form-control form-control-sm"
					placeholder="Keywords for search"
					[(ngModel)]="filters.searchKeywords">
			</div>
		</div>

		<!-- Filter Actions -->
		<div class="d-flex justify-content-end mt-4">
			<button
				type="button"
				class="btn btn-sm btn-light me-3"
				(click)="clearFilters()"
				[disabled]="!hasActiveFilters()">
				<i class="ki-duotone ki-cross fs-2">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				Clear
			</button>
			<button
				type="button"
				class="btn btn-sm btn-primary"
				(click)="applyFilters()">
				<i class="ki-duotone ki-magnifier fs-2">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				Search
			</button>
		</div>
	</div>

	<div class="card-body py-4">
		<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_negotiations">
			<thead>
				<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
					<th class="w-10px pe-2">
						<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
							<input class="form-check-input" type="checkbox" data-kt-check="true" data-kt-check-target="#kt_table_negotiations .form-check-input" value="1" />
						</div>
					</th>
					<th class="min-w-200px">Stock</th>
					<th class="min-w-125px">Customer</th>
					<th class="min-w-150px">Message</th>
					<th class="min-w-150px">Options</th>
					<th class="min-w-100px">Created On</th>
					<th class="min-w-100px">Status</th>
					<th class="min-w-125px">Sales Person</th>
					<th class="text-end min-w-100px">Actions</th>
				</tr>
			</thead>
			<tbody class="text-gray-600 fw-semibold">
				<!-- Loading State -->
				<tr *ngIf="isLoading">
					<td colspan="9" class="text-center py-5">
						<div class="d-flex align-items-center justify-content-center">
							<span class="spinner-border spinner-border-sm me-2"></span>
							<span class="text-gray-600">Loading negotiations...</span>
						</div>
					</td>
				</tr>

				<!-- Empty State -->
				<tr *ngIf="!isLoading && negotiations.length === 0">
					<td colspan="9" class="text-center py-5">
						<div class="d-flex flex-column align-items-center">
							<i class="ki-duotone ki-message-text-2 fs-3x text-gray-400 mb-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
							</i>
							<span class="text-gray-600 fs-6">
								No negotiations found.
							</span>
						</div>
					</td>
				</tr>

				<!-- Negotiation Rows -->
				<tr *ngFor="let negotiation of negotiations; trackBy: trackByNegotiationId">
					<td>
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input class="form-check-input" type="checkbox" [value]="negotiation._id" />
						</div>
					</td>
					<td>
						<div class="d-flex align-items-center">
							<div class="symbol symbol-50px overflow-hidden me-3">
								<div class="symbol-label">
									<img [src]="getCarImage(negotiation)" [alt]="negotiation.car?.name || 'Car'" class="w-100" />
								</div>
							</div>
							<div class="d-flex flex-column">
								<span class="text-gray-800 text-hover-primary mb-1 fw-bold">
									{{ negotiation.car?.name || 'Unknown Car' }}
								</span>
								<span class="text-muted fs-7">
									{{ negotiation.car?.company_name || negotiation.car?.make || '-' }}
								</span>
								<span class="text-muted fs-7" *ngIf="negotiation.car?.inventory_no">
									Stock: {{ negotiation.car?.inventory_no }}
								</span>
							</div>
						</div>
					</td>
					<td>
						<div class="d-flex flex-column">
							<span class="text-gray-800 mb-1">
								{{ negotiation.user?.title }} {{ negotiation.user?.name || 'Unknown Customer' }}
							</span>
							<span class="text-muted fs-7" *ngIf="negotiation.user?.city && negotiation.user?.country">
								{{ negotiation.user?.city }}, {{ negotiation.user?.country }}
							</span>
						</div>
					</td>
					<td>
						<div class="text-gray-800" style="max-width: 200px;">
							<span class="text-truncate d-block" [title]="negotiation.message">
								{{ negotiation.message || 'No message' }}
							</span>
						</div>
					</td>
					<td>
						<div class="d-flex flex-column gap-1">
							<div class="d-flex align-items-center">
								<i class="ki-duotone fs-5 me-2" [ngClass]="negotiation.fob_price ? 'ki-check-circle text-success' : 'ki-cross-circle text-danger'">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-gray-700 fs-7">FOB Price</span>
							</div>
							<div class="d-flex align-items-center">
								<i class="ki-duotone fs-5 me-2" [ngClass]="negotiation.cif_price ? 'ki-check-circle text-success' : 'ki-cross-circle text-danger'">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-gray-700 fs-7">CIF Price</span>
							</div>
							<div class="d-flex align-items-center">
								<i class="ki-duotone fs-5 me-2" [ngClass]="negotiation.cif_total ? 'ki-check-circle text-success' : 'ki-cross-circle text-danger'">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-gray-700 fs-7">CIF Total</span>
							</div>
							<div class="d-flex align-items-center">
								<i class="ki-duotone fs-5 me-2" [ngClass]="negotiation.condition_car ? 'ki-check-circle text-success' : 'ki-cross-circle text-danger'">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-gray-700 fs-7">Condition Car</span>
							</div>
							<div class="d-flex align-items-center">
								<i class="ki-duotone fs-5 me-2" [ngClass]="negotiation.send_photos ? 'ki-check-circle text-success' : 'ki-cross-circle text-danger'">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
								<span class="text-gray-700 fs-7">Send Photos</span>
							</div>
						</div>
					</td>
					<td>{{ formatDate(negotiation.created_at || '') }}</td>
					<td>
						<div class="badge fw-bold" [ngClass]="getStatusBadgeClass(negotiation.status || '')">
							{{ negotiation.status || 'Unknown' | titlecase }}
						</div>
					</td>
					<td>
						<span class="text-gray-800">{{ getSalesPersonName(negotiation) }}</span>
					</td>
					<td class="text-end">
						<div class="d-flex justify-content-end gap-2">
							<button
								type="button"
								class="btn btn-icon btn-sm btn-light-primary"
								(click)="openEditModal(negotiation)"
								title="Edit">
								<i class="ki-duotone ki-pencil fs-4">
									<span class="path1"></span>
									<span class="path2"></span>
								</i>
							</button>
							<button
								type="button"
								class="btn btn-icon btn-sm btn-light-info"
								(click)="openChatModal(negotiation)"
								title="Chat">
								<i class="ki-duotone ki-message-text-2 fs-4">
									<span class="path1"></span>
									<span class="path2"></span>
									<span class="path3"></span>
								</i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Pagination Component -->
	<app-pagination
		[paginationInfo]="paginationInfo"
		[loading]="isLoading"
		(pageChange)="onPageChange($event)">
	</app-pagination>
</div>

<!-- Negotiation Edit Modal -->
<app-negotiation-edit (negotiationUpdated)="onNegotiationUpdated()"></app-negotiation-edit>

<!-- Negotiation Chat Modal -->
<app-negotiation-chat></app-negotiation-chat>
